/***** QRCODES *****/
import { QRCode_Functions } from "@/revamp/composables/db";
/***** BOXES *****/
/***** CHARITIES *****/
import { Charity_Functions } from "@/revamp/composables/db";
/***** INVENTROY *****/
/***** ORDERS *****/
/***** PARAMETERS *****/
/***** PAYMENTREQUESTS *****/
/***** PRODUCTS *****/
/***** RESTAURANTS *****/
import { Outlet_Functions } from "@/revamp/composables/db";
/***** USERS *****/
import { User_Functions } from "@/revamp/composables/db";

import {
  timestamp,
} from "@/revamp/firebase/config";

const useFirebase = () => {
  return {
    ...QRCode_Functions,
    ...Outlet_Functions,
    ...User_Functions,
    ...Charity_Functions,
    timestamp,
  };
};

export default useFirebase;
